import React from 'react'
import cyan1 from '../../images/cyan1.png'
import cyan2 from '../../images/cyan2.png'
import BCA1 from '../../images/BCA1.jpg'
import BCA2 from '../../images/BCA1.jpg'
import BCA3 from '../../images/BCA2.jpg'
import BCA4 from '../../images/BCA3.jpg'
import BCA5 from '../../images/BCA4.jpg'
import BCA6 from '../../images/BCA5.jpg'
import BCA7 from '../../images/BCA7.jpg'
import BCA8 from '../../images/BCA8.jpg'
import BCA9 from '../../images/BCA9.jpg'
import BCA10 from '../../images/BCA10.jpg'
import BCA11 from '../../images/BCA11.jpg'
import BCA12 from '../../images/BCA12.jpg'
import BCA13 from '../../images/BCA13.jpg'
import BCA14 from '../../images/BCA14.jpg'
import BCA15 from '../../images/BCA15.jpg'
import BCA16 from '../../images/BCA16.jpg'
import BCA17 from '../../images/BCA17.jpg'
import BCA18 from '../../images/BCA18.jpg'
import BCA19 from '../../images/BCA19.jpg'
import BCA20 from '../../images/BCA20.jpg'
import BCA21 from '../../images/BCA21.jpg'
import BCA22 from '../../images/BCA22.jpg'
import BCA23 from '../../images/BCA23.jpg'
import BCA24 from '../../images/BCA24.jpg'

import BCA25 from '../../images/BCA25.jpg'
import BCA26 from '../../images/BCA26.jpg'
import BCA27 from '../../images/BCA27.jpg'
import BCA28 from '../../images/BCA28.jpg'
import BCA29 from '../../images/BCA29.jpg'
import BCA30 from '../../images/BCA30.jpg'
import BCA32 from '../../images/BCA32.jpg'
import BCA33 from '../../images/BCA33.jpg'

import BCA35 from '../../images/BCA35.jpg'
import BCA36 from '../../images/BCA36.jpg'
import BCA37 from '../../images/BCA37.jpg'
import BCA38 from '../../images/BCA38.jpg'
import BCA39 from '../../images/BCA39.jpg'
import BCA40 from '../../images/BCA40.jpg'






const First_pane = () => {
  return (
     <div className=''>
           <div
        
        style={{ 
        backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${cyan1})`,
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${cyan1})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingBottom: '50px',
        paddingTop: '100px',
        height: '120vh'
        }}
    
    
    >


        <div className='uk-container'>

            <div className='uk-grid' data-uk-grid>
                <div className='uk-width-1-2@s'>
                    
           <h1 className='light header1 uk-margin-xlarge-top' uk-scrollspy="cls: uk-animation-slide-right; repeat: true">Biote Cyan Apartment</h1>
      
           <h5 className='light uk-margin-medium-top'
            uk-scrollspy="cls: uk-animation-fade; repeat: true">
              
Plot Number: Plot 837, Cad Zone C02,Gwarinpa 1  District              
Plot Title:    Certificate of Occupancy <br/>
Plot Size:    1,215.04M <br/>
Land Use:    Residential<br/>
Mode of Land Acquisition:     Joint Venture<br/>
Total No. Of Housing Units:    9 Units<br/>
Project Start Date:    October 2023<br/>

              
              </h5>
                </div>

                <div className='uk-width-1-2@s'>

                </div>
            </div>

    




        </div>
       
    </div>


        <div className='uk-container uk-text-center uk-margin-large-top' >
         <h3>The Promise</h3>
        <div className='uk-width-1-1'>
            <img src={cyan1} />
        </div>
      </div>




  <div className='uk-container uk-text-center uk-margin-large-top' >
         <h3>Real Realizations</h3>
          
                      
                                    <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA1} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA2} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA3} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>




                                      <div className='row uk-margin-small-top'>
                                         
              
                                          <div className='col-sm-6'>
                                                <img 
                                                  src={BCA5} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-6'>
                                              <img 
                                                  src={BCA6} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>







                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA7} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA8} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA9} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>




              
                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA10} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA11} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA12} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>









                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA13} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA14} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA15} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>








                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA16} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA17} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA18} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>











                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA19} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA20} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA21} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>







                                     
                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA22} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA23} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA24} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>











                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA25} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA26} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA27} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>












                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA28} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA29} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA30} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>


                                        <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA38} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA32} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA33} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>



                                        <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA14} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA35} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA36} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>



                                     <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA37} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BCA38} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BCA39} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>





      </div>

  
      




    </div>
  )
}

export default First_pane